import * as React from 'react'
import { ReactElement } from 'react'
import BaseTagPicker, { BaseTagPickerProps } from './BaseTagPicker'
import useWorkflows from '../../hooks/useWorkflows'

export type WorkflowDto = {
    id: string
    name: string
    enabled: boolean
}

export type WorkflowPickerProps = Partial<BaseTagPickerProps<WorkflowDto>> &
    Required<Pick<BaseTagPickerProps<WorkflowDto>, 'selectedOptions' | 'onOptionsSelect'>>

export default function WorkflowPicker(props: WorkflowPickerProps): ReactElement {
    const { workflows } = useWorkflows()

    return (
        <BaseTagPicker<WorkflowDto>
            entities={workflows}
            filter={workflow =>
                props.filter?.(workflow) ?? (workflow.enabled || props.selectedOptions?.includes(workflow.id))
            }
            alphabetical
            getEntityLabel={unit => unit.name}
            getEntityValue={unit => unit.id}
            placeholderKey={'base.workflowpicker.placeholder'}
            {...props}
        />
    )
}
